import { Capacitor } from '@capacitor/core';
import { httpsCallable } from 'firebase/functions';
import { GoogleAuthProvider, signInWithCredential, signInWithCustomToken } from 'firebase/auth';
import { auth, functions } from '../firebase/firebaseConfig';

export async function hydrateNativeSessionToFirebaseJs(): Promise<boolean> {
  const platform = Capacitor.getPlatform();
  if (platform !== 'ios') return false;

  // If we explicitly forced a sign-out (e.g. after account deletion),
  // avoid re-hydrating the native session back into Firebase JS.
  try {
    if (localStorage.getItem('force_signout') === '1') {
      return false;
    }
  } catch {
  }

  try {
    const { FirebaseAuthentication } = await import('@capacitor-firebase/authentication');

    const current = await FirebaseAuthentication.getCurrentUser();
    const nativeUser = current?.user || null;
    if (!nativeUser) return false;

    const tokenRes = await FirebaseAuthentication.getIdToken({ forceRefresh: false });
    const idToken = String(tokenRes?.token || '').trim();
    if (!idToken) return false;

    if (auth.currentUser?.uid === nativeUser.uid) return true;

    try {
      const credential = GoogleAuthProvider.credential(idToken);
      const res = await signInWithCredential(auth, credential);
      return res.user.uid === nativeUser.uid;
    } catch {
      const exchange = httpsCallable(functions, 'exchangeIdTokenForCustomToken');
      const resp: any = await exchange({ idToken });
      const customToken = String(resp?.data?.customToken || '').trim();
      if (!customToken) return false;
      await signInWithCustomToken(auth, customToken);
      return true;
    }
  } catch {
    return false;
  }
}
